import { useQuery } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { EIN_ORDER_STATUS } from '#client/queries';

export default function useEINOrderStatus({ isSkip = false }) {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { error, errors, data, loading } = useQuery(EIN_ORDER_STATUS, {
    variables: {
      input: {
        businessUuid: businessEntityUuid
      }
    },
    skip: !businessEntityUuid || isSkip,
    skipCache: true,
    noThrow: true
  });

  useLogError(errors, error);
  return {
    isCheckingEINOrderStatus: loading,
    einOrderStatusError: error,
    hasEINOrder: data?.einOrderStatus?.hasOrder
  };
}
